var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('error-dialog', {
    attrs: {
      "status": _vm.editDesignStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.loadDesignStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.submitStatus
    }
  }), _c('sign-in-dialog', {
    scopedSlots: _vm._u([{
      key: "subtitle",
      fn: function () {
        return [_vm._v("Sign in to verify your email address")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _vm.designId ? _c('dialog-scroll-lock', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "no-click-animation": "",
      "content-class": "white fill-height",
      "transition": false
    },
    model: {
      value: _vm.showDesign,
      callback: function ($$v) {
        _vm.showDesign = $$v;
      },
      expression: "showDesign"
    }
  }, [_c('design-edit', {
    attrs: {
      "design-id": _vm.designId,
      "is-applying": true
    },
    on: {
      "update": function ($event) {
        _vm.showDesign = false;
      }
    }
  })], 1) : _vm._e(), _c('h1', {
    staticClass: "text-h3 text-md-h2 my-6 header-font"
  }, [_vm._v("Ellacard design program")]), _c('p', {
    staticClass: "text-md-h6"
  }, [_vm._v("We are looking for creative artists and animators to help us build our catalog of "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-category',
        params: {
          category: 'greeting-cards'
        }
      }
    }
  }, [_vm._v("greeting cards")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-category',
        params: {
          category: 'invitations'
        }
      }
    }
  }, [_vm._v("invitations")]), _vm._v(". Ellacard offers a wide range of card types and aesthetics, including still, photo template, animated cards, and invitations. As such we are interested in many different artistic styles. We work with both freelance artists and studios.")], 1), _c('div', {
    staticClass: "mx-n3 d-flex justify-center relative overflow-hidden",
    staticStyle: {
      "min-height": "288px"
    }
  }, [_c('v-img', {
    class: {
      absolute: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "min-width": "960",
      "aspect-ratio": 3307 / 990,
      "src": "https://ellacard.com/start/header-cards-large.jpg"
    }
  })], 1), _c('h2', {
    staticClass: "text-h4 mb-12"
  }, [_vm._v("Opportunities")]), _c('ul', [_c('li', {
    staticClass: "mb-12"
  }, [_c('h3', {
    staticClass: "text-h5"
  }, [_vm._v("Licensing / per-design rate")]), _c('p', [_vm._v("Ellacard will license your designs non-exclusively – you retain full ownership and can feature or sell your designs on other platforms")])]), _c('li', {
    staticClass: "mb-12"
  }, [_c('h3', {
    staticClass: "text-h5"
  }, [_vm._v("Hourly / contracting")]), _c('p', [_vm._v("Ellacard contracts with freelance artists, firms, and collectives and offers negotiable hourly compensation")])])]), _c('h2', {
    staticClass: "text-h4 mt-16 mb-6"
  }, [_vm._v("Artist rights")]), _c('p', {
    staticClass: "mb-12"
  }, [_vm._v("Artists retain "), _c('i', [_vm._v("full ownership")]), _vm._v(" of licensed designs. This means that you can continue to feature or sell your design on other platforms and remove it from Ellacard at any time. Any designs / samples submitted during the application process will "), _c('i', [_vm._v("not")]), _vm._v(" be surfaced until an agreement is reached.")]), _c('h2', {
    staticClass: "text-h4 mt-16 mb-6"
  }, [_vm._v("How to apply")]), _c('p', {
    staticClass: "mb-6"
  }, [_vm._v("To apply, please fill out the form below. Part of this process includes submitting a sample of your work and using the Ellacard design tools to annotate it with additional information. We prioritize applicants who take the time to create "), _c('i', [_vm._v("interactive")]), _vm._v(" designs, i.e. with user-editable text or photo slots.")]), _c('p', {
    staticClass: "mb-9"
  }, [_vm._v("Please contact us with any questions: "), _c('a', {
    attrs: {
      "href": "mailto:design@ellacard.com"
    }
  }, [_vm._v("design@ellacard.com")])]), _c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('v-card', {
    attrs: {
      "max-width": "800",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Ellacard design program application form")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Full name",
      "disabled": _vm.didSubmit,
      "rules": [function (v) {
        return !!_vm.name;
      }]
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Email address",
      "readonly": "",
      "value": _vm.isSignedIn ? _vm.global.profile.email : null,
      "rules": [function (v) {
        return _vm.isSignedIn;
      }],
      "disabled": _vm.didSubmit
    },
    on: {
      "click": function ($event) {
        _vm.showSignIn = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "small": "",
            "disabled": _vm.didSubmit
          },
          domProps: {
            "textContent": _vm._s(_vm.isSignedIn ? 'Change…' : 'Sign in…')
          },
          on: {
            "click": function ($event) {
              _vm.showSignIn = true;
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c('v-autocomplete', {
    attrs: {
      "label": "Country of residence",
      "type": "country",
      "item-value": "code",
      "item-text": "name",
      "disabled": _vm.didSubmit,
      "items": _vm.COUNTRIES,
      "rules": [function (v) {
        return !!_vm.country;
      }]
    },
    model: {
      value: _vm.country,
      callback: function ($$v) {
        _vm.country = $$v;
      },
      expression: "country"
    }
  }), _c('div', [_vm._v("What type of opportunity are you interested in?")]), _c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "max-width": "500px"
    }
  }, [_c('v-checkbox', {
    staticClass: "mb-sm-3",
    attrs: {
      "hide-details": "",
      "label": "Licensing / per-design rate",
      "value": "per_design",
      "disabled": _vm.didSubmit,
      "rules": [function (v) {
        return !!_vm.opportunities.length;
      }]
    },
    model: {
      value: _vm.opportunities,
      callback: function ($$v) {
        _vm.opportunities = $$v;
      },
      expression: "opportunities"
    }
  }), _c('v-spacer'), _vm.opportunities.includes('per_design') ? _c('v-text-field', {
    staticClass: "ml-8",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "hide-details": "",
      "label": "Expected per-design rate (USD)",
      "placeholder": "0.00",
      "persistent-placeholder": "",
      "prefix": "$",
      "disabled": _vm.didSubmit,
      "rules": [function (v) {
        return /^\d+(\.\d\d)?$/.test(v || '');
      }]
    },
    model: {
      value: _vm.perDesignRate,
      callback: function ($$v) {
        _vm.perDesignRate = $$v;
      },
      expression: "perDesignRate"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "d-flex flex-wrap",
    staticStyle: {
      "max-width": "500px"
    }
  }, [_c('v-checkbox', {
    staticClass: "mb-sm-3",
    attrs: {
      "hide-details": "",
      "label": "Hourly / contracting",
      "value": "per_hour",
      "disabled": _vm.didSubmit,
      "rules": [function (v) {
        return !!_vm.opportunities.length;
      }]
    },
    model: {
      value: _vm.opportunities,
      callback: function ($$v) {
        _vm.opportunities = $$v;
      },
      expression: "opportunities"
    }
  }), _c('v-spacer'), _vm.opportunities.includes('per_hour') ? _c('v-text-field', {
    staticClass: "ml-8",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "hide-details": "",
      "label": "Expected hourly rate (USD)",
      "placeholder": "0.00",
      "persistent-placeholder": "",
      "prefix": "$",
      "disabled": _vm.didSubmit,
      "rules": [function (v) {
        return /^\d+(\.\d\d)?$/.test(v || '');
      }]
    },
    model: {
      value: _vm.perHourRate,
      callback: function ($$v) {
        _vm.perHourRate = $$v;
      },
      expression: "perHourRate"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "mt-6 float-right mb-1 ml-2 relative",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('div', {
    staticClass: "absolute-fill d-flex justify-center align-center",
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    attrs: {
      "fab": "",
      "loading": _vm.editDesignStatus.pending || _vm.loadDesignStatus.pending,
      "disabled": _vm.didSubmit
    },
    on: {
      "click": _vm.editDesign
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  })], 1)], 1), _c('v-textarea', {
    staticClass: "preview",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "hide-details": "",
      "outlined": "",
      "auto-grow": "",
      "readonly": "",
      "disabled": _vm.didSubmit,
      "rules": [function (v) {
        return !!_vm.designId;
      }],
      "value": _vm.designId
    }
  }), _c('div', {
    staticClass: "absolute-fill overflow-hidden",
    staticStyle: {
      "border-radius": "4px",
      "aspect-ratio": "5 / 7"
    }
  }, [_vm.design ? _c('card-preview', {
    attrs: {
      "card": _vm.design
    }
  }) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "mt-6"
  }, [_vm._v("Upload a sample of your work as a card / invitation using the Ellacard design tools")]), _c('ul', [_c('li', [_vm._v("Make sure your design has a meaningful title")]), _c('li', [_vm._v("Create text directly in the Ellacard editor with one of the built-in fonts (instead of including it as part of an image)")]), _c('li', [_vm._v("Add tags to your design so that users can search for it (use the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiTag)
    }
  }), _vm._v(" menu)")], 1), _c('li', [_vm._v("Set a default theme for your design (use the "), _c('v-icon', {
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPalette)
    }
  }), _vm._v(" menu)")], 1), _c('li', [_vm._v("If you're submitting an invitation, link any relevant text to the corresponding "), _c('i', [_vm._v("event")]), _vm._v(" (right-click on a text block and select \"Link text to event\")")])]), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('div', {
    staticClass: "mt-8 mb-1"
  }, [_vm._v("Please share any additional information, e.g. a link to a profile showing relevant work")]), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "3",
      "disabled": _vm.didSubmit
    },
    model: {
      value: _vm.supplemental,
      callback: function ($$v) {
        _vm.supplemental = $$v;
      },
      expression: "supplemental"
    }
  }), _c('div', {
    staticClass: "mb-1"
  }, [_vm._v("How did you find out about the Ellacard design program?")]), _c('v-textarea', {
    attrs: {
      "outlined": "",
      "auto-grow": "",
      "rows": "3",
      "disabled": _vm.didSubmit
    },
    model: {
      value: _vm.referral,
      callback: function ($$v) {
        _vm.referral = $$v;
      },
      expression: "referral"
    }
  })], 1), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.submitStatus.pending,
      "disabled": _vm.didSubmit,
      "type": "submit",
      "color": "primary"
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _c('div', {
    staticClass: "mx-n3 d-flex justify-center relative overflow-hidden",
    staticStyle: {
      "min-height": "288px"
    }
  }, [_c('v-img', {
    class: {
      absolute: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "min-width": "960",
      "aspect-ratio": 3307 / 990,
      "src": "https://ellacard.com/start/header-cards-large.jpg"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }